import setCookie from 'set-cookie-parser';
import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
import { SESSION_COOKIE_NAME } from 'constants/common';
import { isRelativeUrl } from 'utils/urlutils';
export const AFFILIATE_LOGGING_REQUEST = 'AFFILIATE_LOGGING_REQUEST';
export const AFFILIATE_LOGGING_SUCCESS = 'AFFILIATE_LOGGING_SUCCESS';
export const AFFILIATE_LOGGING_ERROR = 'AFFILIATE_LOGGING_ERROR';
/**
 * @param url : Needs to be a valid absolute URL [Important], otherwise the call will fail on mAPI end
 * @param customHeaders : Basically used for specifying session cookie information, so that same cookie get used in this call.
 */
export function handleAffiliateLoggingAction(url, referrer, customHeaders) {
    return (dispatch) => {
        if (__DEBUG_ENV__ && isRelativeUrl(url)) {
            // tslint:disable-next-line
            console.error(new Error(`INVALID url "${url}" supplied in affiliate logging action, URL needs to be absolute.`));
        }
        dispatch({ type: AFFILIATE_LOGGING_REQUEST });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers: Object.assign({}, headers, customHeaders),
            pathname: '/api/2/session/tg-info',
            acceptJson: false,
            action: AFFILIATE_LOGGING_REQUEST
        }), { url, params: { referrer } }).then(response => {
            const cookies = setCookie.parse(response.headers.get('set-cookie'));
            const sessionCookie = cookies.find(item => item.name === SESSION_COOKIE_NAME);
            const newCookie = sessionCookie ? sessionCookie.value : '';
            dispatch({ type: AFFILIATE_LOGGING_SUCCESS, snValue: newCookie });
            return newCookie;
        }, error => {
            dispatch({ type: AFFILIATE_LOGGING_ERROR });
            return Promise.reject(error);
        });
    };
}
